import { useState, useEffect } from 'react';
import { apiFetch } from '../utils/api';

interface TrialDaysData {
  daysRemaining: number;
  isTrialActive: boolean;
  endDate: string | null;
}

export const useTrialDays = () => {
  const [trialData, setTrialData] = useState<TrialDaysData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTrialDays = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiFetch<TrialDaysData>('/trial/days-remaining', { auth: true });
      setTrialData(response);
    } catch (err) {
      console.error('Error fetching trial days:', err);
      setError('Erro ao carregar informações do teste');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrialDays();
  }, []);

  // Atualizar a cada 12 horas (2 vezes por dia)
  useEffect(() => {
    const interval = setInterval(() => {
      fetchTrialDays();
    }, 12 * 60 * 60 * 1000); // 12 horas

    return () => clearInterval(interval);
  }, []);

  return {
    trialData,
    loading,
    error,
    refetch: fetchTrialDays,
  };
};
